import type { BookTimelineLayout } from "@/lib/timeline/book/BookLayout";
import { isPartLocationRun } from "../LocationRun/anchor";
import {
  activeLocationGroupsAtPlayhead,
  type ActiveLocationGroup,
  visibleMemberRunIds,
} from "..";
import { partRunPhase } from "../../rail/PartRunPhase/phase";
import type { LocationRun } from "../LocationRun/runs";

export type {
  ActiveLocationGroup,
  ActiveLocationMember,
  ActiveLocationMemberPhase,
} from "..";

const Z_SITE = 1000;
const Z_PARKED_PART = 1500;
const Z_ACTIVE_PART = 3000;
/** Upcoming part at the handoff slot paints above the part it replaces. */
const Z_UPCOMING_PART = 4000;

export { visibleMemberRunIds };

export function locationVisibilityFromGroups(
  groups: readonly ActiveLocationGroup[],
): Map<string, boolean> {
  const map = new Map<string, boolean>();
  for (const group of groups) {
    for (const member of group.members) {
      map.set(member.runId, member.visible);
    }
  }
  return map;
}

export function locationVisibilityByRunId(
  layout: BookTimelineLayout,
  playheadMs: number,
): Map<string, boolean> {
  return locationVisibilityFromGroups(
    activeLocationGroupsAtPlayhead(layout, playheadMs),
  );
}

export function isLocationRunVisible(
  visibility: ReadonlyMap<string, boolean>,
  runId: string,
): boolean {
  const entry = visibility.get(runId);
  if (entry === undefined) {
    return true;
  }
  return entry;
}

export function locationRunVisibleAtPlayhead(
  layout: BookTimelineLayout,
  run: LocationRun,
  playheadMs: number,
): boolean {
  return isLocationRunVisible(
    locationVisibilityByRunId(layout, playheadMs),
    run.runId,
  );
}

export function locationStackZIndex(
  layout: BookTimelineLayout,
  run: LocationRun,
  playheadMs: number,
  paintOrder: number,
): number {
  if (!isPartLocationRun(run)) {
    return Z_SITE + paintOrder;
  }
  const phase = partRunPhase(layout.rail, run, playheadMs);
  if (phase.kind === "active") {
    return Z_ACTIVE_PART + paintOrder;
  }
  if (phase.kind === "upcoming") {
    return Z_UPCOMING_PART + paintOrder;
  }
  return Z_PARKED_PART + paintOrder;
}
